import React from 'react';

export default function WhatsMentionsPopup({ members = [], query = '', onSelect, position }) {
  if (members.length === 0) return null;

  const normalizedQuery = query.toLowerCase();
  const filtered = members.filter(m => {
    const name = m.name || m.pushName || m.notify || '';
    const jid = m.id || m.jid || '';
    return name.toLowerCase().includes(normalizedQuery) || jid.includes(normalizedQuery);
  }).slice(0, 5); // show top 5

  if (filtered.length === 0) return null;

  return (
    <div style={{
      position: 'absolute',
      bottom: position?.bottom || '100%',
      left: position?.left || 0,
      marginBottom: '8px',
      backgroundColor: '#fff',
      border: '1px solid #d1d7db',
      borderRadius: 'var(--radius-md)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      zIndex: 100,
      width: '250px',
      maxHeight: '200px',
      overflowY: 'auto'
    }}>
      {filtered.map(m => {
        const name = m.name || m.pushName || m.notify || 'Desconocido';
        const rawJid = m.id || m.jid || '';
        const rawNum = rawJid.split('@')[0];
        
        const isLid = rawJid.endsWith('@lid');
        let displayNum = `+${rawNum}`;
        if (isLid || rawNum.length >= 14) {
            displayNum = 'Usuario Oculto';
        } else if (rawNum.startsWith('521') && rawNum.length === 13) {
            // format mexican number nicely for UI
            displayNum = `+52 ${rawNum.slice(3)}`;
        }
        
        const mentionTag = isLid ? `lid:${rawNum}` : rawNum;

        return (
          <div
            key={rawJid}
            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); onSelect(mentionTag); }}
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              borderBottom: '1px solid #f0f2f5',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f2f5'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <div style={{
              width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#00a884',
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '12px', fontWeight: 'bold', overflow: 'hidden'
            }}>
              {m.avatar_url ? (
                <img src={m.avatar_url} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                name.charAt(0).toUpperCase()
              )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: '500', color: '#111', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</div>
              <div style={{ fontSize: '11px', color: '#666' }}>{displayNum}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
